"use client"

import { useRef, type ReactNode } from "react"

import { PageVeil } from "@/components/ui"
import { useFocusTrap } from "@/lib/hooks/use-focus-trap"
import { useOverlayDismiss } from "@/lib/hooks/use-overlay-dismiss"
import { usePinnedPanel } from "@/lib/hooks/use-pinned-panel"

interface NavSheetProps {
  label: string
  scrimLabel: string
  onDismiss: () => void
  children: ReactNode
}

export const NavSheet = ({ label, scrimLabel, onDismiss, children }: NavSheetProps) => {
  const panelRef = useRef<HTMLDivElement>(null)
  useOverlayDismiss(true, onDismiss)
  useFocusTrap(panelRef, true)
  const pinned = usePinnedPanel()

  return (
    <>
      <PageVeil onDismiss={onDismiss} label={scrimLabel} className="lg:hidden" />
      <div
        ref={panelRef}
        role="dialog"
        aria-modal="true"
        aria-label={label}
        style={pinned}
        className="bg-surface rounded-12x shadow-soft z-sticky motion-safe:animate-fade-in-top fixed inset-x-375 overflow-y-auto overscroll-contain py-150 lg:hidden"
      >
        {children}
      </div>
    </>
  )
}
